import React, { useMemo } from 'react';
import { Button, FormControl, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import { IRatingStatus } from './types';
import { AddOutlined } from '@mui/icons-material';
import { IStatus } from 'pages/settings/statuses/base/types';

interface IProps {
  ratingID?: number;
  statusTypes: IStatus[];
  onCreated: (instance:IRatingStatus)=>void;

  newStatusInstance: IRatingStatus|null;
  onChangeNewStatusInstance: (statusInstance:IRatingStatus|null)=>void
  addNewStatus: (statusInstance:IRatingStatus)=>Promise<any>;
}


export default function RequestStatusForm(props:IProps) {

  const {
    statusTypes,
    newStatusInstance,
    onChangeNewStatusInstance,
    addNewStatus
  } = props;

  const instance:IRatingStatus = useMemo(() => {
    if(newStatusInstance !== null) return newStatusInstance;

    return {
      created: '',
      message: '',
      status: null,
      rating: props.ratingID,
    } as IRatingStatus
  }, [props.ratingID, newStatusInstance])


  const handleChange = (name:keyof IRatingStatus) => (event:any) => {
    handleChangeValue(name)(event.target.value);
  };

  const handleChangeValue = (name:keyof IRatingStatus) => (value:any) => {
    instance[name] = value as never;
    const copy_instance = {...instance};
    if(copy_instance.message || copy_instance.status){
      onChangeNewStatusInstance(copy_instance);
    }else{
      onChangeNewStatusInstance(null);
    }
  }


  const add = () => {
    addNewStatus(instance).then((data)=>{
      props.onCreated(data);
      onChangeNewStatusInstance(null);
    })
  }

  if(!statusTypes.length){
    return null;
  }

  return (
    <div>
      <FormControl fullWidth>
        <InputLabel>Статус</InputLabel>
        <Select
          value={instance.status || ""}
          onChange={handleChange('status')}
        >
          {statusTypes.map((i)=>(
            <MenuItem key={i.id} value={i.id}>{i.name}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl fullWidth margin='normal'>
        <TextField
          label="Довільний коментар"
          multiline
          maxRows={4}
          value={instance.message}
          onChange={handleChange('message')}
        />
      </FormControl>
      
      <Typography
        component="div"
        align="right"
      >
        <Button
          variant="contained"
          color="primary"
          size="small"
          startIcon={<AddOutlined />}
          onClick={(e:any) => {
            e.preventDefault();
            add();
          }}
        >
          Додати
        </Button>
      </Typography>
    </div>
  );
}